import React, { useState, useEffect } from "react";
import FormApplication from './components/form';
import {
    Card, Row, Col, Layout, message
} from 'antd';
import moment from 'moment';
import ListAppsAction from './actions/action';

function UpdateApp(props) {
    const { Content } = Layout;
    const [listApp, setListApp] = useState({
        application_name: "",
        link_path: null,
        logo: null,
        day_reminder: null,
        email_pic: [],
        email: null,
        order: null
    });

    const handleChange = (data) => {
      setListApp({
        ...listApp,
        application_name: data.application_name,
        link_path: data.link_path,
        logo: data.logo,
        day_reminder: data.day_reminder,
        email_pic: data.email_pic ? data.email_pic:[],
        order: data.order
      });
    }

    const handleSaveApp = (values) => {
        ListAppsAction({type: 'apps/update'}, sessionStorage.getItem('token'), listApp, props.match.params.id).then((res) => {
          message.info(res.message);
          props.history.push('/apps');
        });
    }

    useEffect(() => {
      ListAppsAction({type: 'apps/show'}, sessionStorage.getItem('token'), null, props.match.params.id).then((res) => {
        handleChange(res)
      });
    }, []);

    return (
        <>
        {/* <Row>
          <Col xs={24}>
            <Card type="inner" title="Edit Application" extra={moment(new Date()).format('DD MMMM YYYY')} />
          </Col>
        </Row> */}
        <Content className="content m-0">
          <Row>
            <Col xs={24}>
              <Card className="body-data">
                <FormApplication title="Create Application" listApp={listApp} setApp={setListApp} handleSave={handleSaveApp} />
              </Card>
            </Col>
          </Row>
        </Content>
      </>
    )
}

export default UpdateApp;